var exports = {
  "i": "x31de4314--6ac40f--wrapper",
};

module.exports = exports;
